import React from 'react'
import classes from './SmallLoader.module.css'

const SmallLoader = ({style}) => {
  return (
    <div className={classes.container} style={style}>
        <div className={classes.spinner}>
            </div>
    </div>
  )
}

export default SmallLoader